export default "__VITE_ASSET__pw6PC3S6__"